import React, { Component } from 'react'
import { Field } from 'redux-form'
import Metadata from './metadataManager'

class MetadataInput extends Component {
  render() {
    const { source, ...rest } = this.props
    if (this.props.source) {
      return <Field {...rest} component={Metadata} name={source} />
    } else {
      return <Metadata {...this.props} />
    }
  }
}

export default MetadataInput
